import react from 'react';
import { message } from "antd"
import { Fonts } from "../utils/constants";

function GetActicidadesEconomicas() : any {
    return new Promise((resolve, reject) => {
        fetch(`https://cotizaws.abcleasing.com.mx:63748/api/ActividadEconomica`)
            .then(response => response.json())
            .then(result => resolve(result))
            .catch(error => {
                reject(error)
                message.error({ content: 'Error al obtener el listado de Actividades económicas', style: { fontFamily: Fonts.sspRegular } });
            })
    })
}

export default GetActicidadesEconomicas